
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import CustomTable from "@/components/CustomTable/index.vue";
import moment from "moment";
import { getWorkbenchCoreDataShop } from "@/api/shouyin";
import { Getter } from "vuex-class";

@Component({
  components: {
    CardContainer,
    CustomTable,
  },
})
export class MultiCoreData extends Vue {
  @Getter multiStoreList!: Array<any>;
  @Prop({ default: () => ({}) }) params!: any;
  isInit = false;
  columns = [
    {
      key: "storeName",
      title: "店铺",
      width: 105,
    },
    {
      key: "totalOrderCountRatio",
      title: "占比",
      align: "left",
      dataType: "proportion",
    },
    {
      key: "totalOrderCount",
      title: "销售笔数",
      align: "right",
      width: 90,
      dataType: "amount",
    },
  ];
  tableDataSource = [
    // {
    //   storeName: "类别类别类别",
    //   totalOrderCountRatio: 0.6,
    //   totalOrderCount: 2300,
    // },
  ];

  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.isInit = false;
    const params = {
      orderType: this.params.orderType,
      queryTimeBegin: this.params.queryTimeBegin,
      queryTimeEnd: this.params.queryTimeEnd,
      storeList: this.multiStoreList.map((item) => {
        return { storeId: item };
      }),
    };
    getWorkbenchCoreDataShop(params).then((res) => {
      this.tableDataSource = (res.data || []).map((item) => {
        return {
          ...item,
          totalOrderCountRatio: Number(
            item.totalOrderCountRatio.replace("%", "") / 100
          ),
        };
      });
      this.isInit = true;
    });
  }
}
export default MultiCoreData;
